<article class="blog-card">
  <a [routerLink]="['/blog', post().slug]" class="blog-card__image-link" tabindex="-1" aria-hidden="true">
    <div class="blog-card__image-wrapper">
      <img
        [src]="post().imageUrl"
        [alt]="post().imageAlt || post().title"
        [width]="post().imageWidth"
        [height]="post().imageHeight"
        class="blog-card__image"
        loading="lazy"
      />
      <span
        class="blog-card__game-badge"
        [style.background-color]="post().game.accentColor"
      >{{ post().game.name }}</span>
    </div>
  </a>

  <div class="blog-card__content">
    <div class="blog-card__meta">
      <time class="blog-card__date" [attr.datetime]="post().publishedAt">{{ post().publishedAt | blogDate }}</time>
      <span class="blog-card__separator">&middot;</span>
      <span class="blog-card__read-time">{{ post().readTimeMinutes | blogReadTime }}</span>
    </div>

    <h3 class="blog-card__title">
      <a [routerLink]="['/blog', post().slug]" class="blog-card__title-link">{{ post().title }}</a>
    </h3>

    <p class="blog-card__excerpt">{{ post().excerpt }}</p>

    <div class="blog-card__categories">
      @for (cat of post().categories; track cat.id) {
        <a
          class="blog-card__category-pill"
          [routerLink]="['/blog']"
          [queryParams]="{ category: cat.slug }"
        >{{ cat.name }}</a>
      }
    </div>

    <!-- B125: la tarjeta pública no trae autor (P41); solo si llega. -->
    @if (post().authorName) {
      <div class="blog-card__author">
        <img
          class="blog-card__avatar"
          [src]="post().authorAvatarUrl"
          [alt]="post().authorName"
          width="32"
          height="32"
          loading="lazy"
        />
        <div class="blog-card__author-info">
          <span class="blog-card__author-name">{{ post().authorName }}</span>
          <span class="blog-card__author-role">{{ post().authorRole }}</span>
        </div>
      </div>
    }
  </div>
</article>
